import { PT_BANK_RAYA_INDONESIA } from 'common/constants';
import {
  setApplicationId,
  setApplicationStatus,
  setError,
  setIsExistWhitelist,
  setOccupationInfo,
  setApplicationIdV3,
  setApplicationStatusV3
} from 'store/actions';

/**
 * to handle success response from payroll verification service
 * @param {*} dispatch
 * @param {*} res
 * @param {*} body
 * @param {*} action
 * @param {*} getState
 * @returns
 */
export const handleSuccessPayrollVerification = (
  dispatch,
  res,
  body,
  action,
  getState,
  isFlowSuplesi = false
) => {
  const resCode = res?.data?.code;
  const data = res?.data?.data;
  const status = data?.applicationStatus?.cmCode;
  const isRayaEmployed = res.data.data?.isRayaEmployed;
  const occupationInfo = getState().loanApply.occupationInfo;
  const isSecondApply = getState().loanApply.appInqRes.isSecondApply;

  if (isFlowSuplesi) {
    dispatch(setApplicationIdV3(data?.applicationId));
    dispatch(setApplicationStatusV3(status));
  } else {
    dispatch(setApplicationId(data?.applicationId));
    dispatch(setApplicationStatus(status));
  }

  dispatch(setIsExistWhitelist(data?.applicationStatus?.isExist));

  if (isRayaEmployed === 'Y' && isSecondApply === 'Y') {
    dispatch(
      setOccupationInfo({
        ...occupationInfo,
        companyName: PT_BANK_RAYA_INDONESIA
      })
    );
  }

  // special error code mapping
  const errorMap = {
    211091: 'contact-cs',
    211051: 'contact-cs',
    4030100: 'not-allow-suplesi'
  };

  if (errorMap[resCode]) {
    dispatch(setError(errorMap[resCode]));
    return;
  }

  // payroll rejection flow
  if (status === 'PAYROLL_REJ') {
    localStorage.setItem(
      'dataVeryRek',
      JSON.stringify({
        bankCode: body.applicationDetails.bankCode,
        bankNumber: body.payrollSessionDetails.payrollAccount,
        ektp: body.applicationDetails.ktpNum
      })
    );
    action?.(status);
    return;
  }

  action?.(status);
};
